import { render, staticRenderFns } from "./SyncFailListItem.vue?vue&type=template&id=da2e11d6&scoped=true&"
import script from "./SyncFailListItem.vue?vue&type=script&lang=ts&"
export * from "./SyncFailListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2e11d6",
  null
  
)

export default component.exports